import { z } from 'zod';

export const PlaceFiscalEmissionEnvironmentSchema = z.enum(['HOMOLOGATION', 'PRODUCTION']);

export const HomologationProductionSampleSchema = z.looseObject({
  required: z.number().int().positive(),
  authorizedCount: z.number().int().nonnegative(),
  distinctValueCount: z.number().int().nonnegative(),
  distinctProductCount: z.number().int().nonnegative(),
  ready: z.boolean(),
});

export const PlaceFiscalEmissionPolicyResponseSchema = z.looseObject({
  placeId: z.uuid(),
  environment: PlaceFiscalEmissionEnvironmentSchema,
  emissionSuspended: z.boolean(),
  homologationSample: HomologationProductionSampleSchema,
});
export type PlaceFiscalEmissionPolicyResponse = z.infer<
  typeof PlaceFiscalEmissionPolicyResponseSchema
>;

export const SwitchPlaceFiscalEnvironmentBodySchema = z.looseObject({
  environment: PlaceFiscalEmissionEnvironmentSchema,
});
export type SwitchPlaceFiscalEnvironmentBody = z.infer<
  typeof SwitchPlaceFiscalEnvironmentBodySchema
>;

export const SetPlaceFiscalEmissionSuspendedBodySchema = z.looseObject({
  emissionSuspended: z.boolean(),
});
export type SetPlaceFiscalEmissionSuspendedBody = z.infer<
  typeof SetPlaceFiscalEmissionSuspendedBodySchema
>;
